<template>
  <div class="columns">
    <div
      class="column is-mobile"
      v-for="i in items.filter((i) => i.habilitado)"
      :key="i.title"
    >
      <router-link :to="i.route" v-if="i.habilitado">
        <div class="card">
          <div class="card-content has-text-centered">
            <h6 class="card-title"><i :class="i.icon" /> {{ i.title }}</h6>
            <p>{{ i.text }}</p>
          </div>
        </div>
      </router-link>
    </div>
    <div class="column is-mobile">
      <a href="https://www.sarah.br/area-paciente/retorno/" target="_blank">
        <div class="card">
          <div class="card-content has-text-centered">
            <h6 class="card-title">
              <i class="icon-ic_patient_orange" />
              {{ this.$t('areas.retorno.titulo') }}
            </h6>
            <p>{{ this.$t('areas.retorno.informacao') }}</p>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardMenu',
  props: {
    profile: {
      type: String,
      default: () => ''
    },
    internado: {
      type: Boolean
    }
  },
  beforeMount() {
    if (this.profile === 'Inativo') {
      this.items = [
        {
          route: '/atendimento',
          icon: 'icon-ic_patient_orange',
          title: this.$t('areas.solicitacao.titulo'),
          text: this.$t('areas.solicitacao.informacao'),
          habilitado: this.releaseSolicitacao
        }
      ]
    } else {
      this.items = [
        {
          route: '/agenda',
          icon: 'icon-ic_calendar_orange',
          title: this.$t('areas.agenda.titulo'),
          text: this.$t('areas.agenda.informacao'),
          habilitado: true
        },
        {
          route: '/resultado-de-exame',
          icon: 'icon-ic_document_checked-orange',
          title: this.$t('areas.exames.titulo'),
          text: this.$t('areas.exames.informacao'),
          habilitado: !this.internado
        },
        {
          route: '/documentos',
          icon: 'icon-ic_file_text-orange',
          title: this.$t('areas.documentos.titulo'),
          text: this.$t('areas.documentos.informacao'),
          habilitado: !this.internado
        }
        /* {
          route: '/atendimento',
          icon: 'icon-ic_patient_orange',
          title: this.$t('areas.solicitacao.titulo'),
          text: this.$t('areas.solicitacao.informacao'),
          habilitado: false
        } */
      ]
    }
  },
  data() {
    return {
      items: []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';

.card {
  padding: 0.75rem;
  min-width: 16.875rem;
  width: 100%;
  height: 7.6875rem;
  border: 0.0625rem solid $neutral-color-4;
  border-color: var(--neutral-color-4);
  border-radius: 0.25rem;
  box-shadow: none;

  background-color: var(--bg-color-card);

  i {
    padding-bottom: 0.3125rem;
  }

  .card-content {
    padding: 0;
  }

  .card-title {
    display: inline-grid;

    color: var(--light-blue);
    font-size: 1.25rem;
    font-weight: $font-semi-bold;

    line-height: 1.5rem;
  }

  p {
    font-weight: $font-normal;
    font-size: 0.875rem;
    line-height: 1rem;
    padding-top: 0.9375rem;
  }
}

.card:hover {
  border-bottom: 0.2rem solid var(--light-blue);
  border-color: var(--light-blue);
  cursor: pointer;
}

@media (max-width: 64rem) {
  .card {
    max-width: 100%;
  }
}
</style>
